import React from 'react';
import PropTypes from 'prop-types';

import downloadCsvIcon from '../../assets/images/download-csv-icon.svg';
import uploadCsvIcon from '../../assets/images/upload-csv-icon.svg';
import { INSTRUCTIONS_COPY } from './constants';

/**
 * Displays instructions for adding providers to the roster.
 *
 * @param {Object} props
 * @param {Function} props.onDownloadTemplate - Callback when download template button is clicked
 * @param {Function} props.onUploadCSV - Callback when upload CSV button is clicked
 */
const InstructionsSection = ({ onDownloadTemplate, onUploadCSV }) => {
  return (
    <div className="flex flex-col gap-5 pb-5 mb-5">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between border-b border-gray-20 pb-5 gap-4 lg:gap-0">
        <h1 className="text-2xl font-semibold text-gray-90">
          Add Providers to Roster
        </h1>
        <div className="flex items-center gap-4 lg:gap-10">
          <button
            type="button"
            onClick={onDownloadTemplate}
            className="flex items-center gap-2 text-blue-30 font-semibold text-base hover:opacity-80 transition-opacity"
            aria-label="Download CSV template"
          >
            <img src={downloadCsvIcon} alt="" className="w-5 h-5 shrink-0" />
            <span>Download template</span>
          </button>
          <button
            type="button"
            onClick={onUploadCSV}
            className="flex items-center gap-2 text-blue-30 font-semibold text-base hover:opacity-80 transition-opacity"
            aria-label="Upload CSV"
          >
            <img src={uploadCsvIcon} alt="" className="w-5 h-5 shrink-0" />
            <span>Upload CSV</span>
          </button>
        </div>
      </div>
      <ol className="list-decimal pl-5 text-sm space-y-3 marker:font-bold">
        <li>
          <b>{INSTRUCTIONS_COPY.ADD_PROVIDER.EMPHASIS}</b>{' '}
          {INSTRUCTIONS_COPY.ADD_PROVIDER.BODY}
        </li>
        <li>
          <b>{INSTRUCTIONS_COPY.ONCE_VERIFIED.EMPHASIS}</b>{' '}
          {INSTRUCTIONS_COPY.ONCE_VERIFIED.BODY}
        </li>
        <li>
          <b>{INSTRUCTIONS_COPY.AFTER_PURCHASE.EMPHASIS}</b>{' '}
          {INSTRUCTIONS_COPY.AFTER_PURCHASE.BODY_BEFORE_EMAIL}{' '}
          <a
            href={INSTRUCTIONS_COPY.AFTER_PURCHASE.SUPPORT_EMAIL_HREF}
            className="text-blue-50"
          >
            {INSTRUCTIONS_COPY.AFTER_PURCHASE.SUPPORT_EMAIL}
          </a>
          .
        </li>
      </ol>
    </div>
  );
};

InstructionsSection.propTypes = {
  onDownloadTemplate: PropTypes.func.isRequired,
  onUploadCSV: PropTypes.func.isRequired,
};

export default InstructionsSection;
